<template>
    <div>
        <!-- 详情 -->
        <div class="item-top">
            <div class="top-timeOut">
                兑奖期限：获奖后当天生效，有效天数20天
            </div>
            <div class="top-imgBox">
                <img class="top-img" :src="require('@/assets/LotteryInteractive/bg.png')" alt="">
            </div>
            <div class="top-title">
                华为手机华为手机华为手机华为手机华为手机华为手机华为手机华为手机
            </div>
        </div>
        <div class="item-line">

        </div>
        <!-- 获奖人信息 -->
        <div class="item-bottom">
            <div class="bottom-title">获奖人信息</div>
            <div>
                <div class="item-info" style="align-items: center;">
                    <div class="info-left">用户名</div>
                    <div class="" style="display: flex;align-items: center;">
                        <img class="info-img" :src="require('@/assets/LotteryInteractive/bg.png')" alt="">
                        <div class="info-right">杨幂</div>
                    </div>
                </div>
                <div class="item-info">
                    <div class="info-left">手机号码</div>
                    <div class="info-right">15996988989</div>
                </div>
                <div class="item-info">
                    <div class="info-left">获奖时间</div>
                    <div class="info-right">2021-03-26 12:00</div>
                </div>
                <div class="item-info">
                    <div class="info-left">领奖状态</div>
                    <div class="info-right" style="color: #44BB57;">已发货</div>
                    <div class="info-right" style="color: #E3833D;">未领取</div>
                    <div class="info-right" >已领取</div>
                    <div class="info-right" style="color: #999999;">已失效</div>
                </div>
                <div class="item-info">
                    <div class="info-left">收货人</div>
                    <div class="info-right">低了热巴张嘉译张嘉译张嘉译张嘉译张嘉译张嘉译</div>
                </div>
                <div class="item-info">
                    <div class="info-left">手机号码</div>
                    <div class="info-right">15869698589</div>
                </div>
                <div class="item-info">
                    <div class="info-left">发货时间</div>
                    <div class="info-right">2023-10-12 12:00</div>
                </div>
                <div class="item-info">
                    <div class="info-left">收货地址</div>
                    <div class="info-right">河南省郑州市管城回族区</div>
                </div>
                <div class="item-info" style="height: 18px;">
                    <div style="display: flex;align-items: center;">
                        <div class="info-left" >快递单号</div>
                        <div class="info-right">20232555222655225552</div>
                    </div>
                    <img class="info-copy" :src="require('@/assets/LotteryInteractive/copy.png')" alt="">
                </div>
                <div class="item-info">
                    <div class="info-left">快递公司</div>
                    <div class="info-right">中通</div>
                </div>
            </div>
        </div>
        <div style="height: 90px;"></div>
        <!-- <div class="item-btn" style="justify-content: center;">
            <div class="btn-text" @click="goHome">返回首页</div>
        </div> -->
        <div class="item-btn" style="justify-content: space-around;">
            <div class="btn-text2" @click="goHome">返回首页</div>
            <div class="btn-text2-ling" @click="goReceive">立即领取</div>
        </div>
        <div class="item-pop">
            <van-popup class="item-liuPop" v-model="messageShow">
                <div>
                    <div class="liuPop-title">
                        <span style="color: red;font-size: 16px;">*</span>
                        <span style="font-size: 16px;">收货人</span>
                    </div>
                    <input style="margin-bottom: 20px;" class="liuPop-input" type="text" placeholder="请填写收货人">
                    <div class="liuPop-title">
                        <span style="color: red;font-size: 16px;">*</span>
                        <span style="font-size: 16px;">手机号</span>
                    </div>
                    <input class="liuPop-input" style="margin-bottom: 20px;" type="number" placeholder="请填写手机号">
                    <div class="liuPop-title">
                        <span style="color: red;font-size: 16px;">*</span>
                        <span style="font-size: 16px;">收货地址</span>
                    </div>
                    <input class="liuPop-input" type="text" placeholder="请填写收货地址">
                    <div class="liuPop-btn">
                        <div class="liuPop-cancel" @click="messageShow = false">
                            取消
                        </div>
                        <div class="liuPop-submit">
                            提交
                        </div>
                    </div>
                </div>
            </van-popup>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            messageShow:false
        }
    },
    methods: {
        goHome () {
            window.location.href = '/lotteryInteractive';
        },
        goReceive () {
            this.messageShow = true
        }
    }
}
</script>
<style scoped>
.item-top {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.top-timeOut {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
}

.top-title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    margin: 0 20px;
}

.top-imgBox {
    width: 160px;
    height: 102px;
    background: #DEDEDE;
    border-radius: 4px 4px 4px 4px;
    margin: 16px 12px;
    text-align: center;
}

.top-img {
    width: 102px;
    height: 102px;
}

.item-line {
    width: 100%;
    height: 5px;
    background: #F3F3F3;
    margin: 30px 0;
}

.item-bottom {
    margin: 0 16px;
}

.bottom-title {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 16px;
    color: #333333;
}

.item-info {
    display: flex;
    margin-top: 20px;
}

.info-img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-right: 8px;
}

.info-left {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    margin-right: 8px;
    width: 56px;
    text-align: right;
}

.info-right {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    flex: 1;
}

.item-btn {
    position: fixed;
    width: 100%;
    left: 0;
    right: 0;
    bottom: 35px;
    display: flex;
    align-items: center;
}

.btn-text {
    background: #E9F3FF;
    border-radius: 49px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #347CCF;
    padding: 11px 90px;

}
.btn-text2 {
    background: #E9F3FF;
    border-radius: 49px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #347CCF;
    padding: 11px 46px;

}
.btn-text2-ling {
    background: #347CCF;
    border-radius: 49px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    padding: 11px 46px;
}
.info-copy {
    width: 18px;
    height: 18px;
    margin-left: 10px;
}
.item-pop {
    width: 100%;
}
.item-liuPop {
    width: 290px;
    height: auto;
    background: #FFFFFF;
    border-radius: 12px 12px 12px 12px;
    padding: 20px;
}

.liuPop-title {
    display: flex;
    align-items: center;
}

.liuPop-btn {
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.liuPop-cancel {
    width: 127px;
    height: 44px;
    background: #E9F3FF;
    border-radius: 32px 32px 32px 32px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #347CCF;
    line-height: 44px;
    text-align: center;
    margin-top: 40px;
}

.liuPop-submit {
    width: 127px;
    height: 44px;
    background: #347CCF;
    border-radius: 32px 32px 32px 32px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 44px;
    text-align: center;
    margin-top: 40px;
}

.liuPop-input {
    width: 270px;
    border-radius: 6px 6px 6px 6px;
    border: #E3E3E3 1px solid;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 12px;
    color: #999999;
    padding: 8px;
}
</style>